import { Component, OnInit } from "@angular/core";
import { MDBModalRef } from 'ng-uikit-pro-standard';

@Component({
  selector: "ll-no-access",
  templateUrl: "./no-access.component.html",
  styleUrls: ["./no-access.component.scss"]
})
export class NoAccessComponent implements OnInit {
  constructor(public modalRef: MDBModalRef) {}

  ngOnInit() {}
  closeError = () => this.modalRef.hide();
}
